import Component from '../Component';

const { RichText } = wp.blockEditor;

export default class Text extends Component {
  static attributes(name) {
    return {
      type: 'string',
      source: 'text',
      selector: '[bb="' + name + '"]',
      default: '',
    };
  }

  render() {
    if (this.isView()) {
      return (
        <RichText.Content
          bb={this.name}
          tagName={this.props.tagName || 'p'}
          value={this.attr()}
          className={this.props.className || this.name}
        />
      );
    }

    return (
      <RichText
        bb={this.name}
        tagName={this.props.tagName || 'p'}
        value={this.attr()}
        className={this.props.className || this.name}
        onChange={val => this.setAttr(val)}
        placeholder={this.props.placeholder || 'Write some content'}
      />
    );
  }
}
